export default __webpack_public_path__ + "moray_camera.1f93cc83.png";